import {
  Card,
  Container,
  Stack,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
  Chip
} from '@mui/material';
import React, { useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { tipsSelector, alltips, selectTip } from '../slices/tipsSlice';

import Page from '../components/Page';
import { ApiStatus, escapeRegExp } from '../utils/constants';
import QuickSearchToolbar from '../utils/search_toolbar';

function Tips() {
  const { tips, status } = useSelector(tipsSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchText, setSearchText] = React.useState('');
  const [rows, setRows] = React.useState([]);

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
    const filteredRows = tips.filter((row) =>
      Object.keys(row).some(
        (field) => row[field] !== null && searchRegex.test(row[field].toString())
      )
    );
    setRows(filteredRows);
  };

  useEffect(() => {
    setRows(tips);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tips]);

  useEffect(() => {
    dispatch(alltips());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { field: 'id', headerName: 'ID', width: 90, valueGetter: (params) => params.row.tip_id },
    {
      field: 'icon',
      headerName: '',
      width: 40,
      sortable: false,
      renderCell: (params) => (
        <img alt="" src={process.env.REACT_APP_IMAGE_URL + params.row.image} />
      )
    },
    {
      field: 'tip_title',
      headerName: 'Title',
      flex: 1
    },
    {
      field: 'tip_isResolved',
      headerName: 'Status',
      renderCell: (params) =>
        params.row.tip_isResolved ? (
          <Chip label="Resolved" color="success" />
        ) : (
          <Chip label="Unresolved" color="error" />
        )
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 200,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <Button
            variant="contained"
            onClick={() => {
              dispatch(selectTip(params.row.tip_id));
              navigate(`/dashboard/tips/tip/${params.row.tip_id}`);
            }}
          >
            Details
          </Button>
        </Stack>
      )
    }
  ];

  return (
    <Page title="Team">
      <Backdrop style={{ zIndex: 100, color: '#fff' }} open={status === ApiStatus.loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Tips
          </Typography>
        </Stack>
        <Card>
          <DataGrid
            components={{ Toolbar: QuickSearchToolbar }}
            getRowId={(row) => row.tip_id.toString()}
            autoHeight
            rows={rows}
            columns={columns}
            pageSize={50}
            rowsPerPageOptions={[50, 100]}
            checkboxSelection
            disableSelectionOnClick
            componentsProps={{
              toolbar: {
                value: searchText,
                onChange: (event) => requestSearch(event.target.value),
                clearSearch: () => requestSearch('')
              }
            }}
          />
        </Card>
      </Container>
    </Page>
  );
}

export default Tips;
